// extracted by mini-css-extract-plugin
var _1 = "Deadlines-modulewidth100__MbArg";
export { _1 as "width100" }
